import type { RequestParams } from '../requests/http-client';
import { ContentType, HttpClient } from '../requests/http-client';
import type {
  BaseErrorResponse,
  CheckVerificationReq,
  CreateVerificationReq,
  CreateVerificationRes,
  SendVerificationRes,
} from './data-contracts';


export default function useVerification() {
  class Verification<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Verification
     * @name VerificationControllerCreateVerification
     * @summary Create verification
     * @request POST:/cs2/verification
     * @secure
     * @response `200` `CreateVerificationRes`
     * @response `400` `BaseErrorResponse`
     */
    verificationControllerCreateVerification = (data: CreateVerificationReq, params: RequestParams = {}) =>
      this.request<CreateVerificationRes, BaseErrorResponse>({
        path: '/cs2/verification',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Verification
     * @name VerificationControllerCheckVerification
     * @summary Check verification
     * @request POST:/cs2/verification/check
     * @secure
     * @response `200` `SendVerificationRes`
     * @response `400` `BaseErrorResponse`
     */
    verificationControllerCheckVerification = (data: CheckVerificationReq, params: RequestParams = {}) =>
      this.request<SendVerificationRes, BaseErrorResponse>({
        path: '/cs2/verification/check',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Verification();
}
